export default {
  props: ['errors', 'value', 'label', 'placeholder', 'addon', 'textarea', 'options', 'mode'],
  data: function () {
    return {
      isPlaceholderVisible: true,
      innerVal: '',
    }
  },
  mounted() {
    this.$nextTick(() => {
      !!this.value ? (this.innerVal = this.value) : null
      // !!this.value ? this.options.unshift({value: '', label: ''}) : null; // if value is empty, we unshift one empty value at begining
    })
  },
  watch: {
    innerVal: {
      handler: function () {
        this.$emit('input', this.innerVal)
      },
    },
  },
  methods: {
    // OLD BINDINGS - do not delete
    // updateValue(value) {
    //   this.innerVal = value;
    //   this.$emit('input', value);
    // },
    onFocus() {
      this.isPlaceholderVisible = false
    },
    onBlur() {
      this.isPlaceholderVisible = true
    },
    computedValue(option) {
      if (!option) {
        return ''
      } else if (this.value == option.value || this.innerVal == option.value) {
        return `+${option.value}`
      } else {
        return `+${option.value} ${option.label}`
      }
    },
  },
}
